module.exports = __webpack_public_path__ + "static/media/pemadanan_npwp.92bb6e58.png";